/**
 * @generated SignedSource<<1c6e815880e36fbc24d97028c71096e9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrgHomeRegularQuery$variables = Record<PropertyKey, never>;
export type OrgHomeRegularQuery$data = {
  readonly viewer: {
    readonly workspaces: ReadonlyArray<{
      readonly id: string;
      readonly permission: {
        readonly read: boolean;
        readonly write: boolean;
      };
      readonly timezone: string;
    }> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"OrgHomeMasterComponent_query">;
};
export type OrgHomeRegularQuery = {
  response: OrgHomeRegularQuery$data;
  variables: OrgHomeRegularQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timezone",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkspacePermission",
  "kind": "LinkedField",
  "name": "permission",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "read",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "write",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgHomeRegularQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "OrgHomeMasterComponent_query"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgHomeRegularQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organisation",
        "kind": "LinkedField",
        "name": "organisation",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbhash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlExpiresAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "features",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasAdminAccess",
            "storageKey": null
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Workspace",
            "kind": "LinkedField",
            "name": "workspaces",
            "plural": true,
            "selections": [
              (v0/*: any*/),
              (v1/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentId",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v3/*: any*/),
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f94b9cbadd54f876645a489a8caf0424",
    "id": null,
    "metadata": {},
    "name": "OrgHomeRegularQuery",
    "operationKind": "query",
    "text": "query OrgHomeRegularQuery {\n  ...OrgHomeMasterComponent_query\n  viewer {\n    workspaces {\n      id\n      timezone\n      permission {\n        read\n        write\n      }\n    }\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment OrgHomeMasterComponent_query on Query {\n  organisation {\n    name\n    logo {\n      id\n      ...Image_image\n    }\n    features\n    hasAdminAccess\n    id\n  }\n  viewer {\n    workspaces {\n      id\n      timezone\n      ...WorkspaceSelector_workspaces\n      ...WorkspaceBreadcrumbs_workspaces\n    }\n  }\n  me {\n    email\n    ...OrgLogoutButton_me\n    id\n  }\n}\n\nfragment OrgLogoutButton_me on User {\n  name\n  email\n}\n\nfragment WorkspaceBreadcrumbs_workspaces on Workspace {\n  id\n  name\n  parentId\n}\n\nfragment WorkspaceSelectorContent_workspaces on Workspace {\n  id\n  name\n  parentId\n}\n\nfragment WorkspaceSelector_workspaces on Workspace {\n  id\n  name\n  parentId\n  ...WorkspaceSelectorContent_workspaces\n}\n"
  }
};
})();

(node as any).hash = "56f3d18b3c66f957ef89c5842abc6a9e";

export default node;
